import { searchBox as searchBoxWidget } from "instantsearch.js/es/widgets";

export const searchBox = () =>
    searchBoxWidget({
        container: "#search-box",
    });
